import React from 'react';
import Table from '../Table/Table';

interface DataTableProps {
  data: any[];
}

const DataTable: React.FC<DataTableProps> = ({ data }) => {
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const columns = [
    {
      header: 'Source',
      accessor: 'source',
      sortable: true,
      cell: (row: any) => <span className="source-cell">{row.source}</span>
    },
    {
      header: 'Total Records',
      accessor: 'total_records',
      sortable: true,
      cell: (row: any) => <span className="total-cell">{row.total_records.toLocaleString()}</span>
    },
    {
      header: 'Published',
      accessor: 'published',
      sortable: true,
      cell: (row: any) => <span className="status-cell published">{row.status_counts.published || 0}</span>
    },
    {
      header: 'Unpublished',
      accessor: 'unpublished',
      sortable: true,
      cell: (row: any) => <span className="status-cell unpublished">{row.status_counts.unpublished || 0}</span>
    },
    {
      header: 'In Progress',
      accessor: 'in_progress',
      sortable: true,
      cell: (row: any) => <span className="status-cell in-progress">{row.status_counts.in_progress || 0}</span>
    },
    {
      header: 'Invalid File',
      accessor: 'invalid_file',
      sortable: true,
      cell: (row: any) => <span className="status-cell invalid-file">{row.status_counts.invalid_file || 0}</span>
    },
    {
      header: 'Failed',
      accessor: 'failed',
      sortable: true,
      cell: (row: any) => <span className="status-cell failed">{row.status_counts.failed || 0}</span>
    },
    {
      header: 'Filename Invalid',
      accessor: 'filename_invalid',
      sortable: true,
      cell: (row: any) => <span className="status-cell filename-invalid">{row.status_counts.filename_invalid || 0}</span>
    },
    {
      header: 'Date Range',
      accessor: 'date_range',
      sortable: false,
      cell: (row: any) => (
        <div className="date-cell">
          <div className="date-range">
            <div className="date-label">From:</div>
            <div className="date-value">{formatDate(row.date_range.earliest_date)}</div>
            <div className="date-label">To:</div>
            <div className="date-value">{formatDate(row.date_range.latest_date)}</div>
          </div>
        </div>
      )
    }
  ];

  return (
    <div className="data-table-container">
      <h3>Detailed Data</h3>
      <Table
        data={data}
        columns={columns}
        isExpandable={false}
      />
    </div>
  );
};

export default DataTable;
